import * as Common from "./common";

export interface StraightWallModel {
    wallSections: StraightWallSection[];
}

export interface StraightWallSection extends WallSection {
    heightRetainingWall: number;
}

export interface CurvedWallSectionModuleModel extends Common.Module {
    options: CurvedWallSecionModuleOption[];
}

export interface StraightWallSectionModuleModel extends Common.Module {
}

export interface CurvedWallSecionModuleOption {
    id: string;
    description: string;
    sectionType: number;
    curveDirection: CurvedWallSectionDirection;
    sectionAngle: number;
    applicableProperies: ApplicableCurvedWallProperies;
}

export interface ApplicableCurvedWallProperies {
    height: boolean;
    length: boolean;
    direction: boolean;
    coping: boolean;
}

export enum CurvedWallSectionDirection {
    Straight = 0,
    Left = 1,
    Right = 2
}

export interface CurvedWallModel {
    wallSections: CurvedWallSection[];
}

export interface WallSection {
    name: string;
    heightAboveGround: number;
    length: number;
}

export interface CurvedWallSection extends WallSection {
    sectionType: CurvedWallSectionTypes;
    direction: CurvedWallSectionDirection;
    angle: number;
    coping?: boolean;

    selectedOption: CurvedWallSecionModuleOption;
}

export enum CurvedWallSectionTypes {
    Straight = 0,
    Pillar = 1,
    Opening = 2,
    Corner = 3,
    Curve = 4
}
